// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Ce79 center","light":"Button_light__3brjt","dark":"Button_dark__2BeNt","border":"Button_border__3eGfg"};